"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exitFullscreen = exports.ifNotFullscreen = exports.enterFullscreen = void 0;
const plugin_fullscreen_1 = __importDefault(require("@jspsych/plugin-fullscreen"));
const fscreen_1 = __importDefault(require("fscreen"));
const taskStore_1 = require("../../../taskStore");
const taskSetup_1 = require("../../taskSetup");
const audioHandler_1 = require("../helpers/audioHandler");
const detectInput_1 = require("../../../utils/detectInput");
exports.enterFullscreen = {
    type: plugin_fullscreen_1.default,
    // force fullscreen on a touchscreen so that audio context can be unlocked
    fullscreen_mode: !!fscreen_1.default.fullscreenEnabled || taskSetup_1.isTouchScreen,
    message: () => {
        const t = (0, taskStore_1.taskStore)().translations;
        return `<div class="lev-row-container header">
        <p>${t.generalFullscreen || 'Switch to full screen mode'}</p>
      </div>
      `;
    },
    delay_after: 0,
    keyboard_choices: 'ALL_KEYS',
    button_label: () => `${(0, taskStore_1.taskStore)().translations.continueButtonText || 'Continue'}`,
    on_load: () => {
        const continueButton = document.getElementById('jspsych-fullscreen-btn');
        if (continueButton) {
            continueButton.id = 'dummy';
            continueButton.classList.add('primary');
        }
        if (taskSetup_1.isTouchScreen) {
            continueButton === null || continueButton === void 0 ? void 0 : continueButton.addEventListener('touchstart', () => {
                audioHandler_1.PageAudioHandler.unlockAudioContext();
            }, { once: true });
        }
        else {
            continueButton === null || continueButton === void 0 ? void 0 : continueButton.addEventListener('mousedown', () => {
                audioHandler_1.PageAudioHandler.unlockAudioContext();
            }, { once: true });
        }
        const inputDetector = (0, detectInput_1.setupInputDetection)();
        (0, taskStore_1.taskStore)('inputCapability', inputDetector.capability);
    },
    on_start: () => {
        document.body.style.cursor = 'default';
    },
};
exports.ifNotFullscreen = {
    timeline: [exports.enterFullscreen],
    conditional_function: () => fscreen_1.default.fullscreenElement === null,
};
exports.exitFullscreen = {
    type: plugin_fullscreen_1.default,
    fullscreen_mode: false,
    delay_after: 0,
};
